import styled from 'styled-components';

export const Layout = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: var(--gap);
  position: relative;
  max-width: 1300px;
  margin: auto;
`;
